// This file is for modularized imports for next/server to get fully-treeshaking.
export { NextResponse as default } from "../spec-extension/response";

//# sourceMappingURL=next-response.js.map